export default __webpack_public_path__ + "static/media/banner.71d8351d.png";